import React, { useState } from "react"
import VizSensor from "react-visibility-sensor"
import classnames from "classnames"

// Components
import Pic from "../images/pic"

//CSS
import componentStyle from "./steps.module.css"

const Steps = () => {
  const [isVisible, setVisibility] = useState(false)

  let baseClass = classnames(
    "grid",
    "grid-cols-12",
    { "opacity-0": !isVisible },
    { "text-slide-in": isVisible }
  )
  const {
    stepCard,
    stepOne,
    stepTwo,
    stepThree,
    instructions,
    instructionsOne,
    stepCase,
    stepNumber,
  } = componentStyle

  const card = classnames(
    stepCard,
    "lg:col-span-3",
    "col-span-12",
    "lg:mb-0",
    "mb-20"
  )

  return (
    <section id="steps" className="h-full">
      <VizSensor
        onChange={setVisibility}
        active={!isVisible}
        partialVisibility={true}
      >
        <div className={baseClass}>
          <div className="col-start-2 lg:col-start-3 col-span-10 my-12">
            <h1 className="font-medium text-left text-gray-800 text-4xl lg:text-4xl">
              Solo 3 pasos para estar protegido
            </h1>
          </div>
          <div className="col-start-2 lg:col-start-3 col-span-10 lg:mb-12">
            <div className="grid grid-cols-12 lg:gap-6">
              <div className={card}>
              <p className={instructionsOne }>Contesta el formulario</p>
                <div className={stepCase}>
                  <p className={stepNumber}>1</p>
                </div>
                <div className={stepOne}>
                  <Pic filename="home/StepOne.png" />
                </div>
              </div>
              <div className={card}>
              <p className={instructions}>Escoge tu plan</p>
                <div className={stepCase}>
                  <p className={stepNumber}>2</p>
                </div>
                <div className={stepTwo}>
                  <Pic filename="home/StepTwo.png" />
                </div>
              </div>
              <div className={card}>
              <p className={instructions}>Regístrate y paga</p>
              <div className={stepCase}>
                  <p className={stepNumber}>3</p>
                </div>
                <div className={stepThree}>
                  <Pic filename="home/StepThree.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </VizSensor>
    </section>
  )
}

export default Steps
